import React, { createContext, useContext, useMemo } from "react";
import it from "@/i18n/it.json";
import en from "@/i18n/en.json";

const DICTIONARIES = { it, en };
export const SUPPORTED_LANGS = ["it", "en"];
export const DEFAULT_LANG = "it";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: (k) => k, dict: it });

function resolvePath(dict, key) {
  return key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), dict);
}

export function I18nProvider({ lang, children }) {
  const value = useMemo(() => {
    const normalized = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
    const dict = DICTIONARIES[normalized];
    const t = (key, fallback) => {
      const val = resolvePath(dict, key);
      if (val === undefined) return fallback !== undefined ? fallback : key;
      return val;
    };
    return { lang: normalized, dict, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function useT() {
  return useContext(I18nContext).t;
}
